export default Object.freeze({
  NEAREST: "Nearest",
  ALPHABETICAL: "Alphabetical",
  PRICE: "Price",
  RATING: "Rating",
});
